module.exports = __webpack_public_path__ + "static/media/Douglas-MacKrell-Headshot.78c87f7b.jpg";